import { inject, Injectable } from '@angular/core';
import { DestroyableComponent } from '@models/destroyable.component';
import { CustomLocaleService } from '@onclass/oc-custom-locale';

// Todo. Remove.
@Injectable({
  providedIn: 'root',
})
export class i18nService extends DestroyableComponent {
  private readonly t_srv = inject(CustomLocaleService);

  public setTranslation(lang: string, translations?: any, force: boolean = false) {
    this.t_srv.language = lang;
  }

  public instant(key: string, options: any = {}): string {
    return this.t_srv.translate(key, options);
  }

  public directInstant(key: string): string {
    return this.removeZeroWidthSpace(this.t_srv.instant(key));
  }

  public use(lang: string) {
    this.t_srv.language = lang;
  }

  public get languageAsync(): string {
    return this.t_srv.language;
  }

  public get currentLang(): string {
    return this.t_srv.language;
  }

  /*
   */
  public hasZeroWidthSpace(str: string): boolean {
    // Zero width space (U+200B)
    // Zero width non-joiner (U+200C)
    // Zero width joiner (U+200D)
    // Zero width no-break space (U+FEFF)
    return /[\u200B\u200C\u200D\uFEFF]/.test(str);
  }

  /*
   */
  public removeZeroWidthSpace(str: string): string {
    // Удаляем все zero width символы:
    // Zero width space (U+200B)
    // Zero width non-joiner (U+200C)
    // Zero width joiner (U+200D)
    // Zero width no-break space (U+FEFF)
    return str.replace(/[\u200B\u200C\u200D\uFEFF]/g, '');
  }
}
